import CustomModal from "../CustomModal";

function EnableLocationModal({
  isOpen,
  handleClose,
  location,
  handleEnableLocation,
}) {
  if (!location) return null;
  return (
    <CustomModal isOpen={isOpen} onRequestClose={handleClose} className="delete-modal">
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/enable-modal-img.png`}
          alt="Enable location icon"
        />
        <b>
          <p>Are you sure you want to enable this location?</p>
        </b>
        <div className="details-container container">
          <div className="detail">
            <p>Name</p>
            <b>
              <p className="D">{location.name}</p>
            </b>
          </div>
          <div className="detail">
            <p>Location ID</p>
            <b>
              <p className="D">#{location.id}</p>
            </b>
          </div>
          <div className="detail">
            <p>Status</p>
            <b>
              <p className="D">{location.status === "active" ? "Active" : "Inactive"}</p>
            </b>
          </div>
        </div>
        <div className="warning">
          <img
            src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
            alt="Information icon"
          />
          <p>
            Enabling this location will enable all access to associated data, including membership details, attendance records, and any other information linked to this location.
          </p>
        </div>
        <div className="inner-member-btn">
          <button onClick={handleClose}>Cancel</button>
          <button
            style={{ backgroundColor: "#34B159", color: "#FAFAFA" }}
            onClick={handleEnableLocation}
          >
            Enable Location
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default EnableLocationModal;
